<template>
  <div class="container">
    <h4 class="title is-4">Evaluators Overview</h4>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input" v-model="filters.name" @keyup.enter="refreshData()" />
      </div>
      <div class="control">
        <button class="button" @click="refreshData()" @keyup.enter="refreshData()">Search</button>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="select">
            <select v-model="filters.pageSize" @change="refreshData()">
              <option :value="20">20 per page</option>
              <option :value="50">50 per page</option>
              <option :value="100">100 per page</option>
              <option :value="100">250 per page</option>
              <option :value="999999">All results</option>
            </select>
          </div>
        </div>
      </div>
      <div class="level-right">
        <button class="button">
          <router-link 
            :to="{ name: 'StaffAddEvaluator' }"
            target="_blank"
          >Add Evaluator</router-link>
        </button>
        <button class="button" style="marginLeft: 0.5rem;">
          <router-link 
            :to="{ name: 'StaffUploadEvaluators' }"
            target="_blank"
          >Bulk Upload Evaluators</router-link>
        </button>
      </div>
    </div>
    <loading-box v-if="!dataLoaded"></loading-box>
    <div v-if="dataLoaded">
      <pagination
        :pagination-details="paginationDetails"
        @update="refreshData($event)"
      ></pagination>
      <div v-if="updatingData">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-half has-text-centered" style="margin-top: 150px">
            <i class="fa fa-refresh fa-spin fa-5x"></i>
          </div>
          <div class="column"></div>
        </div>
      </div>
      <table class="table" v-if="!updatingData">
        <thead>
          <tr>
            <th>Name</th>
            <th>Applications</th>
            <th>Send Email</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="evaluator in evaluators" :key="evaluator.id">
            <td>
              <router-link 
                :to="{ name: 'EvaluatorDetail', params: { evaluatorId: evaluator.id } }"
                target="_blank"  
              >{{ evaluator.fullName }}
              </router-link>
            </td>
            <td>
              <span
                class="tag"
                :class="{
                  'is-primary': userCompletedAssignment(evaluator, assignment.id),
                  'is-warning': userStartedAssignment(evaluator, assignment.id),
                }"
                v-for="assignment in evaluator.currentAssignments"
                :key="assignment.id"
              >
                <router-link
                  :to="{
                    name: 'StaffApplicationReviewDetail',
                    params: { applicationId: assignment.id },
                  }"
                  target="_blank"
                >
                  {{ assignment.organizationName }}
                </router-link>
              </span>
            </td>
            <td>
              <button class="button" @click="sendEmailToEvaluator(evaluator)">
                Send Individual Email
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <BulkEmailModal
        v-if="showModal"
        :users="selectedEvaluators"
        @close="showModal = !showModal"
        @submit="refreshData()"
      />

    </div>
  </div>
</template>

<script>
import User from '@/services/users'
import LoadingBox from '@/components/LoadingBox'
import Pagination from '@/components/Pagination'
import BulkEmailModal from '@/components/emails/BulkEmailModal'

import { getPaginationDataFromResponse } from '@/services/pagination'

export default {
  components: { LoadingBox, Pagination, BulkEmailModal },
  data() {
    return {
      dataLoaded: false,
      updatingData: false,
      isLoading: false,
      searchQuery: '',
      evaluators: {},
      paginationDetails: {},
      selectPage : false,
      showModal: false,
      selectedEvaluators: [],
      filters: {
        name: '',
        isEvaluator: true,
        pageSize: 50,
      },
    }
  },
  watch: {
    selectedEvaluators(newEvaluators) {
      //console.log("selectedEvaluators");
      //console.log(this.selectedEvaluators);
      //console.log(newEvaluators);
      if (newEvaluators.length !== this.evaluators.length) {
        this.selectPage = false
      }
      newEvaluators.forEach((value, index) => {
        //console.log(value.status);
        if (value.status == "CANCELED")
        {
          //console.log ("CANCELED!!!!!")
          this.$delete(newEvaluators, index) 
        }
      });
 
      //console.log(newEvaluators);
      //console.log(this.selectedEvaluators);
    },
  },
  created() {
    this.refreshData()
  },
  methods: {
    toggleSelectPage() {
      //console.log("toggleSelectPage");
      if (this.selectPage) {
        this.selectedEvaluators = [...this.evaluators]
      } else {
        this.selectedEvaluators = []
      }
    },
    sendEmailToEvaluator(evaluator) {
      //console.log("sendEmailToEvaluator");
      if (this.selectPage) {
        this.toggleSelectPage()
      } else {
        this.selectedEvaluators = []
      }
      this.selectedEvaluators = [evaluator]
      this.showModal = true
    },
    refreshData(page = null) {
      this.showModal = false
      this.selectedEvaluators = []
      this.updatingData = true
      let dataFilters = {}
      if (page) {
        dataFilters = { ...this.filters, page: page }
      } else {
        dataFilters = { ...this.filters }
      }
      User.api.list({ filters: dataFilters }).then(data => {
        this.paginationDetails = getPaginationDataFromResponse(data)
        this.evaluators = data.results
        //console.log(this.evaluators)
        this.updatingData = false
        this.dataLoaded = true
      })
    },
    getEvaluatorStatusClass(evaluator) {
      if (evaluator) {
        if (!evaluator.pendingAsEvaluator) {
          return { class: { 'is-success': true }, label: 'APPROVED' }
        } else {
          return { class: {}, label: 'PENDING' }
        }
      }
    },
    updateEvaluator(evaluator, approvalStatus) {
      let newEvaluator = User.create(evaluator)
      newEvaluator.pendingAsEvaluator = !approvalStatus
      const fields = ['pendingAsEvaluator']
      User.api.update(newEvaluator, fields).then(() => {
        this.refreshData()
      })
    },
    userCompletedAssignment(user, applicationId) {
      if (
        user.currentEvaluations.find(
          evaluation => (evaluation.application === applicationId) & evaluation.isCompleted,
        )
      ) {
        return true
      } else {
        return false
      }
    },
    userStartedAssignment(user, applicationId) {
      if (
        user.currentEvaluations.find(
          evaluation =>
            (evaluation.application === applicationId) &
            !evaluation.isCompleted &
            !evaluation.isEmpty,
        )
      ) {
        return true
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped>
.tag {
  margin: 0 10px;
}

.fixed-width {
  word-wrap: break-word;
  width: 180px;
}

.is-success > .child-of-application-link {
  color: white;
}
</style>
